export const constantStyles = {
  paperBorder: '1px solid rgba(0, 0, 0, 0.12)',
  paperBorderRadius: '8px',
};
